export function toggleActiveAgencies(agencies, agency_id) {
  return agencies?.agency_id.includes(agency_id)
    ? agencies?.agency_id.filter((activeAgency) => activeAgency !== agency_id)
    : agencies?.agency_id.concat(agency_id);
}
